import React from 'react';
import './TutorGreen.css';

const TutorModal = ({ isVisible, onClose, handleImageUpload, loading, updateImage }) => {
  if (!isVisible) return null; // Render nothing if the modal is not visible

  return (
    <div
      className="fixed inset-0  bg-opacity-75 flex justify-center items-center z-50"
      style={{ backdropFilter: 'blur(5px)' }}
    >
      <div className="bg-white rounded-lg shadow-custom-full  max-w-lg w-full mx-5 sm:mx-auto">
        <div className="flex justify-between py-3 px-5 items-center border-b shadow-md border-green-300">
          <h1 className='text-green-900 text-xl font-montserrat modalTitle'>Profile picture upload</h1>
          <button
            onClick={onClose}
            className="w-8 h-8 rounded-full flex justify-center items-center "
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-8 w-8"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
          </button>
        </div>
        <div className='px-5 py-4'>
          <h1 className='text-green-900 text-lg font-montserrat modalTitle'>Profile Picture</h1>
          <p className='text-green-700 text-md font-montserrat '>Your profile image is an indicator of recognizing you. By following the given photo upload guidelines, upload a professional image.</p>
        </div>
        <div className="mt-5 px-5">
          <div className="mx-auto w-full ">
            <label className="flex w-full cursor-pointer appearance-none items-center justify-center rounded-md border-2 border-dashed border-gray-200 p-6 transition-all hover:border-primary-300">
              <div className="space-y-1 text-center">
                <div className="mx-auto inline-flex h-10 w-10 items-center justify-center rounded-full bg-gray-100">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    strokeWidth="1.5"
                    stroke="currentColor"
                    className="h-6 w-6 text-gray-500"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M12 16.5V9.75m0 0l3 3m-3-3l-3 3M6.75 19.5a4.5 4.5 0 01-1.41-8.775 5.25 5.25 0 0110.233-2.33 3 3 0 013.758 3.848A3.752 3.752 0 0118 19.5H6.75z"
                    />
                  </svg>
                </div>
                <p className="text-sm text-gray-500">
                  SVG, PNG, JPG or GIF (max. 800x400px)
                </p>
              </div>
              <input
                id="imageUpload"
                type="file"
                accept="image/*"
                onChange={handleImageUpload}
                className="sr-only"
              />
            </label>
          </div>
          {loading ? (
            <button
              className="my-5  flex justify-center items-center text-white w-32 h-10 rounded-lg bg-green-700 font-roboto hover:bg-green-900"
              disabled
            >
              Uploading...
            </button>
          ) : (
            <button
              className="my-5  flex justify-center items-center text-white w-32 h-10 rounded-lg bg-green-700 font-roboto hover:bg-green-900"
              onClick={updateImage}
            >
              Upload Image
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default TutorModal;
